import React from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';

const LogoutPage: React.FC = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    const handleLogout = async () => {
      await signOut();
      navigate('/');
    };

    handleLogout();
  }, [signOut, navigate]);

  return null; // This component doesn't render anything
};

export default LogoutPage;